import { styled } from '@material-ui/core';
import { Alert, Input, FormLabel } from '@ds/react-components';

export const FormContainer = styled('div')({});

export const InfoAlert = styled(Alert)({
  marginTop: '18px',
  maxWidth: '910px',
});

export const FormInput = styled(Input)({
  maxWidth: '380px',
});

export const LabelContainer = styled('div')({
  marginBottom: '8px',
});

export const CancellationFeeLabel = styled(FormLabel)({
  marginBottom: 0,
});

export const CancellationFeeSideText = styled('span')(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.common.lightText,
  fontStyle: 'italic',
  lineHeight: '17px',
  fontWeight: '400',
  textShadow: 0,
}));

export const CancellationFeeSubLabel = styled('p')(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.common.lightText,
  padding: '0',
  margin: 0,
  lineHeight: '14px',
}));
